import React, { useEffect } from 'react';
import { SingleCommonType } from '../../types';
import { commonBackInfo } from '../../utils';
import { useKeywordDefaultValue } from '../../hooks/init';
import { keywordsReplaceText, parseRule } from '../KeyWordsSelect/utils';
import { Form, Justify } from 'tea-component';
import { useRequestFontWebConfig } from '@op/hooks/useFrontWebConfig';
import TagList from '../../components/TagList';
import useLanguage from '@op/hooks/useLanguage';
import AutoTextAreaBox from '../../components/AutoTextAreaBox';
import { getKeywordPalaceholder } from '../../utils/keyword';

export default function KeywordInputPreview({
  gameInfo,
  onChange,
  defaultValue,
  filterValue,
  oriDefaultFilter,
  backOriDefaultValue,
  lang,
}: SingleCommonType) {
  const {
    values,
    vagueValues,
    excludeValues,
    keywordActiveId,
    keywordCustomInput,
    customKeywordList,
    keywordSearchType,
    setKeywordCustomInput,
    setKeywordSearchType,
    grammarTrue,
    grammarText,
    customInputConfirm,
  } = useKeywordDefaultValue({
    defaultValue,
    filterValue,
    dealwithCustomInput: parseRule,
  });

  const { formatMessage, isEn } = useLanguage();

  function getKeywordFilterValue() {
    let deleteKeys: Array<string> = ['keywords_list', 'merge_keywords_list'];
    let data: any = {
      keyword: values,
      isKeywordFilter: true,
      keywordActiveId,
      like_math_keywords: vagueValues,
      like_math_exclude_keywords: excludeValues,
    };
    if (keywordActiveId === 'custom') {
      deleteKeys = [
        'keyword',
        'like_math_keywords',
        'like_math_exclude_keywords',
      ];
      const isExtend = keywordSearchType === 'extend';
      deleteKeys.push(isExtend ? 'keywords_list' : 'merge_keywords_list');
      data = {
        isKeywordFilter: true,
        [isExtend ? 'merge_keywords_list' : 'keywords_list']: customKeywordList,
        keywordActiveId,
        keywordCustomInput,
        keywordSearchType,
      };
    }

    return { deleteKeys, data };
  }

  useEffect(() => {
    const handler = setTimeout(() => {
      customInputConfirm(parseRule(keywordCustomInput));
    }, 300);

    return () => {
      clearTimeout(handler);
    };
  }, [keywordCustomInput]);

  useEffect(() => {
    const { data, deleteKeys } = getKeywordFilterValue();
    onChange?.(
      'keyword',
      commonBackInfo(data, {
        keyWords: keywordCustomInput,
        keywordSearchType,
        keywordActiveId,
        keywordCustomInput,
      }),
      deleteKeys,
    );
  }, [
    values,
    excludeValues,
    vagueValues,
    customKeywordList,
    keywordActiveId,
    keywordSearchType,
  ]);

  const { keyword_analysis_shortcut } = useRequestFontWebConfig({
    keys: [{ key: 'keyword_analysis_shortcut', defaultValue: [] }],
    gameInfo,
  });

  return (
    <div className={'keyword-preview-wrapper'}>
      <Form.Item>
        <Justify
          className="dbo-analysis-url-row"
          top
          left={formatMessage({ id: 'Keyword Search' })}
          right={
            <TagList
              list={keyword_analysis_shortcut}
              isEn={isEn}
              setValue={setKeywordCustomInput}
            ></TagList>
          }
        />

        <AutoTextAreaBox
          value={keywordCustomInput}
          replaceText={keywordsReplaceText}
          grammarTrue={grammarTrue}
          grammarText={formatMessage(grammarText)}
          setValue={setKeywordCustomInput}
          placeholder={getKeywordPalaceholder(formatMessage)}
        ></AutoTextAreaBox>
      </Form.Item>
    </div>
  );
}
